import React from 'react';
import ReactPlayer from 'react-player';

interface IProps {
  ref?: (player: Player) => void;

  url: string;
  autoplay?: boolean;
}

interface IState {
  autoplay?: boolean;
  url:string;
  pip:boolean;
  playing:boolean;
  controls:boolean;
  volume:number;
  muted:boolean;
  playbackRate:number;
  loop:boolean;
}
class Player extends React.Component<IProps, IState> {
  state : IState = {
    url: './',
    pip: false,
    playing: false,
    controls: true,
    volume: .6,
    muted: false,
    playbackRate: 1.0,
    loop: false
  };
  player: ReactPlayer | null = null;

  componentDidMount = () => Player.getDerivedStateFromProps(this.props, this.state);
  static getDerivedStateFromProps = (p : IProps, s : IState) : IState => {
    let res : IState = { } as IState;
    if (p?.url !== s?.url) res.url = p.url;
    if (p?.autoplay !== s?.autoplay) res.autoplay = p.autoplay;
    return res;
  }

  /** saltar a una posición */
  setPosition = (index:number) => this.player?.seekTo(index);

  render() {
    return <>
      <ReactPlayer
          ref={e => this.player = e}
          className='react-player'
          url={this.state.url}
          pip={this.state.pip}
          playing={this.state.playing}
          controls={this.state.controls}
          loop={this.state.loop}
          playbackRate={this.state.playbackRate}
          volume={this.state.volume}
          muted={this.state.muted}
          progressInterval={1}
          
          onReady={() => this.state.autoplay && this.setState({ playing: true })}
          onPlay={() => this.setState({ playing: true })}
          onEnablePIP={() => this.setState({ pip: true })}
          onDisablePIP={() => this.setState({ pip: false })}
          onPause={() => this.setState({ playing: false })}
          onEnded={() => this.setState({ playing: this.state.loop })}
            /*
          onStart={() => console.log('onStart')}
          onPlay  = {() =>  {
                              console.log('onPlay', played)
                              setPlaying(true);
                            }
                    }
          onEnablePIP = {() => 
                          {
                            console.log('onEnablePIP')
                            setPip(true)
                          }
                        }
          onDisablePIP  = {() => 
                            {
                              console.log('onDisablePIP')
                              setPip(false)
                            }
                          }
          onPause=  {() =>  {
                              console.log('onPause');
                              setPlaying(!playing);
                            }
                    }
          onSeek  = {e => {
                            console.log('onSeek', e);
                            setPlayed(e);
                          }
                    }
          onBuffer={() => console.log('onBuffer')}
          onPlaybackRateChange={() => console.log('onPlaybackRateChange')}                    
          onEnded = {() =>  {
                              console.log('onEnded')
                              setPlaying(loop)
                            }
                    }
          onError={e => console.log('onError', e)}
          onProgress={e => console.log('onProgress', e)}
          onDuration={e => console.log('onDuration', e)}
          */
        />

    </>
  }
}

export { Player };
